import { useTheme, useMediaQuery } from '@mui/material';

export const useDashboardResponsive = () => {
  const theme = useTheme();

  // Sehr kleine Screens (< 400px) - z.B. sehr schmale Viewports
  const isVerySmall = useMediaQuery('(max-width: 399px)');
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  // Nur bei sehr großen Screens (>= 1536px / 2xl) erlauben wir rowSpan > 1
  const isLargeDesktop = useMediaQuery('(min-width: 1536px)');

  const getModuleProps = (defaultCol, defaultRow) => {
    // Bei sehr kleinen Screens: rowSpan immer 1, minHeight auto
    if (isVerySmall) {
      return {
        colSpan: 1,
        rowSpan: 1,
        minHeight: 'auto',
      };
    }
    if (isMobile) {
      return {
        colSpan: 1,
        rowSpan: 1,
        minHeight: '200px',
      };
    }
    if (isTablet) {
      return {
        colSpan: Math.min(defaultCol, 1),
        rowSpan: 1,
        minHeight: 'auto',
      };
    }
    // Desktop aber nicht large: rowSpan auf 1 begrenzen
    if (isDesktop && !isLargeDesktop) {
      return {
        colSpan: defaultCol,
        rowSpan: 1,
        minHeight: 'auto',
      };
    }
    // Large Desktop (>= 1536px): volle Werte erlaubt
    return {
      colSpan: defaultCol,
      rowSpan: Math.min(defaultRow, 2),
      minHeight: 'auto',
    };
  };

  const shouldShowGantt = isLargeDesktop;

  return {
    isMobile,
    isTablet,
    isDesktop,
    isLargeDesktop,
    isVerySmall,
    getModuleProps,
    shouldShowGantt,
  };
};
